export class PutDataCatalogExternalContextDocumentRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "content",
            "baseName": "content",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return PutDataCatalogExternalContextDocumentRequest.attributeTypeMap;
    }
    constructor() {
    }
}
